let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("93K9M"), load("5aUoq"), load("k9ktU")]).then(() => parcelRequire('iFaMg'));